import { jsxs as _jsxs } from "react/jsx-runtime";
import { useFormatting } from "../formatting/useFormatting.js";
import { LabeledValue } from "./LabeledValue.js";
export const LabeledDurationValue = ({ label, value = 0, ...otherProps }) => {
    const { getFormattedDuration } = useFormatting();
    return (_jsxs(LabeledValue, { label: label, color: "primary", ...otherProps, children: [getFormattedDuration(value), " h"] }));
};
//# sourceMappingURL=LabeledDurationValue.js.map